import { API } from ".";

export const GET_SITE_FEATURES_REQUEST = "@@feature/GET_SITE_FEATURES_REQUEST";
export const GET_SITE_FEATURES_SUCCESS = "@@feature/GET_SITE_FEATURES_SUCCESS";
export const GET_SITE_FEATURES_FAILURE = "@@feature/GET_SITE_FEATURES_FAILURE";

export function getSiteFeatures(id) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: GET_SITE_FEATURES_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/site/${id}/feature`);
      dispatch({
        type: GET_SITE_FEATURES_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SITE_FEATURES_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_FEATURES = "@@feature/CLEAR_FEATURES";

export function clearFeatures() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_FEATURES,
    });
  };
}
